module.exports = __webpack_public_path__ + "img/noticeoff.ca1a3747.png";